import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListPaymentMethodRequest extends IBaseRequest {
    limit?: number;
    offset?: number;
    orderBy?: string;
    countOnly?: boolean;
    id?: string;
    orderByType?: string;
    treeHandle?: string;
}

export class ListPaymentMethodRequest extends BaseRequest implements IListPaymentMethodRequest {
    public limit?: number;
    public offset?: number;
    public orderBy?: string;
    public countOnly?: boolean;
    public id?: string;
    public orderByType?: string;
    public treeHandle?: string;

    constructor(server: string, session: string, otherOptions?: any) {
        super(server, session);
        this.limit = otherOptions?.limit;
        this.offset = otherOptions?.offset;
        this.orderBy = otherOptions?.orderBy;
        this.countOnly = otherOptions?.countOnly;
        this.id = otherOptions?.id;
        this.orderByType = otherOptions?.orderByType;
        this.treeHandle = otherOptions?.treeHandle;
    }

    public toXml(): string {
        var parameters: string = super.toXml();

        parameters += this.makeNode(this.limit, 'limit');
        parameters += this.makeNode(this.offset, 'offset');
        parameters += this.makeNode(this.orderBy, 'orderBy');
        parameters += this.makeNode(this.countOnly, 'countOnly');
        parameters += this.makeNode(this.id, 'id');
        parameters += this.makeNode(this.orderByType, 'orderByType');
        parameters += this.makeNode(this.treeHandle, 'treeHandle');

        return super.wrapperXml('ListPaymentMethod', parameters);
    }
}
